import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ApiService } from "@api/core";
import { HistoryType, QuestionMetadata, AddressType, Gender, DocumentType, Sport, ExamType, TelephoneType } from "@api/domain";
import { Activity, NewGenericCodeDescription, ObjectiveTarget, PersonSegment, ReferencialData, SportPosition, StaffPosition } from './domain.model';

const API_URL = "domain";

@Injectable()
export class DomainApiService {
  constructor(private apiService: ApiService) { }

  getHistoryTypes(): Observable<HistoryType[]> {
    return of([
      {
        id: 1,
        description: "Historia Clinica",
        module_name: "paciente.historia_clinica",
      } as HistoryType,
      {
        id: 2,
        description: "Historia Deportiva",
        module_name: "paciente.historia_deportiva",
      } as HistoryType,
      {
        id: 3,
        description: "Historia Alimentaria",
        module_name: "paciente.historia_alimentaria",
      } as HistoryType,
      // {
      //   id: 4,
      //   description: "Objetivos Composicion Corporal",
      //   module_name: "paciente.objetivos_composicion_corporal",
      // } as HistoryType,
      {
        id: 5,
        description: "Formulario de Consulta",
        module_name: "paciente.consulta_medica",
      } as HistoryType,
    ]);
  }

  getObjectiveTargets(): Observable<ObjectiveTarget[]> {
    return of([
      {
        id: "GAIN_CC",
        description: "Aumento MM",
      } as ObjectiveTarget,
      {
        id: "LOSE_CC",
        description: "Bajar MA",
      } as ObjectiveTarget,
      {
        id: "MAINTAIN_CC",
        description: "Mantener CC",
      } as ObjectiveTarget,
    ]);
  }

  getQuestionMetadata(): Observable<QuestionMetadata[]> {
    return this.apiService.get<QuestionMetadata[]>(
      API_URL,
      `/questionMetadata`
    );
  }

  getAddressTypes(): Observable<AddressType[]> {
    return this.apiService.get<AddressType[]>(API_URL, `/addressType`);
  }

  getGenders(): Observable<Gender[]> {
    return this.apiService.get<Gender[]>(API_URL, `/genderType`);
  }

  getDocumentTypes(): Observable<DocumentType[]> {
    return this.apiService.get<DocumentType[]>(API_URL, `/documentType`);
  }

  getInstitutions(): Observable<Array<{ id: number, name: string }>> {
    return this.apiService.get(API_URL, `/accounts`);
  }

  getSports(instituteId: string): Observable<Sport[]> {
    return this.apiService.get<Sport[]>(API_URL, `/sports?instituteId=` + instituteId);
  }

  getExamTypes(): Observable<ExamType[]> {
    return this.apiService.get<ExamType[]>(API_URL, `/typesMedicalExam`);
  }

  getPhoneTypes(): Observable<TelephoneType[]> {
    return of([
      {
        id: 1,
        description: "Celular",
      } as TelephoneType,
    ]);
  }

  getStaffPositions(): Observable<StaffPosition[]> {
    return this.apiService.get<StaffPosition[]>(API_URL, `/staffPosition`);
  }

  getActivities(): Observable<Activity[]> {
    return this.apiService.get<Activity[]>(API_URL, `/activitiesMets`);
  }

  getReferencialData(instituteId: number | string, sportId: number, positionId: number, genderCode: string): Observable<ReferencialData> {
    return this.apiService.get<ReferencialData>(API_URL, `/referencialDatas?genderCode=${genderCode}&instituteId=${instituteId}&sportId=${sportId}&positionId=${positionId}`);
  }

  getSegments(instituteId: string): Observable<PersonSegment[]> {
    return this.apiService.get<PersonSegment[]>(API_URL, `/personSegments?accountId=` + instituteId);
  }

  saveNewSport(instituteId: string, sport: NewGenericCodeDescription): Observable<Sport> {
    return this.apiService.post(API_URL, '/group?accountId=' + instituteId, sport);
  }

  saveEditSport(instituteId: number | string, sportId: number, sport: NewGenericCodeDescription): Observable<Sport> {
    return this.apiService.put(API_URL, `/group/${sportId}?accountId=${instituteId}`, sport);
  }

  deleteSport(sportId: number | string, instituteId: string): Observable<any> {
    return this.apiService.delete(API_URL, `/group/${sportId}?accountId=${instituteId}`);
  }

  saveNewPosition(sportId: number | string, position: NewGenericCodeDescription): Observable<SportPosition> {
    return this.apiService.post(API_URL, `/subGroup?groupId=${sportId}`, position);
  }

  saveEditPosition(sportId: number | string, positionId: number, position: NewGenericCodeDescription): Observable<SportPosition> {
    return this.apiService.put(API_URL, `/subGroup/${positionId}?groupId=${sportId}`, position);
  }

  deletePosition(positionId: number | string, sportId: number, instituteId: number | string): Observable<any> {
    return this.apiService.delete(API_URL, `/subGroup/${positionId}?groupId=${sportId}&accountId=${instituteId}`);
  }

  saveNewReferencialData(instituteId: number | string, refData: ReferencialData): Observable<ReferencialData> {
    return this.apiService.post(API_URL, `/referencialData?accountId=${instituteId}`, refData);
  }

  saveEditReferencialData(instituteId: number | string, refData: ReferencialData): Observable<ReferencialData> {
    return this.apiService.put(API_URL, `/referencialData/${refData.id}?accountId=${instituteId}`, refData);
  }

  saveEditSegment(instituteId: number | string, segment: PersonSegment): Observable<PersonSegment> {
    return this.apiService.put(API_URL, `/personSegment/${segment.id}?accountId=${instituteId}`, segment);
  }

  saveNewSegment(instituteId: number | string, segment: PersonSegment): Observable<PersonSegment> {
    return this.apiService.post(API_URL, `/personSegment?accountId=${instituteId}`, segment);
  }


}
